import { render, staticRenderFns } from "./WhitePath.vue?vue&type=template&id=471a8e68&"
import script from "./WhitePath.vue?vue&type=script&lang=js&"
export * from "./WhitePath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports